import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import { useLocation, useNavigate } from 'react-router'
import { checkIsActive, KTSVG, WithChildren } from '../../../helpers'
import { useLayout } from '../../core'

type Props = {
  to?: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const AsideMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
}) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const isActive = checkIsActive(pathname, to ? to : '')
  const { config } = useLayout()
  const { aside } = config
  const [isExpanded, setIsExpanded] = useState(isActive)

  useEffect(() => {
    if (isActive) {
      setIsExpanded(true)
    }
  }, [isActive])

  const handleClick = () => {
    setIsExpanded(!isExpanded)
    if (to) {
      navigate(to)
    }
  }

  return (
    <div
      className={clsx('menu-item', { 'here show': isActive || isExpanded }, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span
        className={clsx('menu-link justify-content-between', { active: isActive })}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2x' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title fs-4 fw-bold'>{title}</span>
        <span className='menu-title d-flex justify-content-end'>
          <span className='menu-arrow'></span>
        </span>
      </span>
      <div
        className={clsx('menu-sub menu-sub-accordion', {
          'menu-active-bg': isActive,
          show: isExpanded,
        })}
        style={{ display: isExpanded ? 'block' : 'none' }}
      >
        {children}
      </div>
    </div>
  )
}

export { AsideMenuItemWithSub }
